import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getReport(report){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = report;
    appendTokenName(data);
    return apiAction({
        types: ["GET_REPORT_REQUESTED", "GET_REPORT_SUCCESS", "GET_REPORT_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getTotalUsers(report){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = report;
    data.name = "total_users";
    appendTokenName(data);
    return apiAction({
        types: ["GET_TOTALUSERS_REQUESTED", "GET_TOTALUSERS_SUCCESS", "GET_TOTALUSERS_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getAgent(agent){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = agent;
    data.name = "agent_resource_utilization";
    data.filters = {"server_id": agent.server_id};
    appendTokenName(data);
    return apiAction({
        types: ["GET_AGENT_REQUESTED", "GET_AGENT_SUCCESS", "GET_AGENT_FAILED"],
        method: "POST",
        path: "admin/get_agent_report/",
        body: data
    });
}

export function getAgentGraph(filters){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name =  "agent_resource_utilization";
    appendTokenName(data);
    return apiAction({
        types: ["GET_AGENTGRAPH_REQUESTED", "GET_AGENTGRAPH_SUCCESS", "GET_AGENTGRAPH_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getActiveUsers(filters){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name =  "active_users";
    appendTokenName(data);
    return apiAction({
        types: ["GET_ACTIVE_USERS_REQUESTED", "GET_ACTIVE_USERS_SUCCESS", "GET_ACTIVE_USERS_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getLogins(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name = "logins_by_hour";
    appendTokenName(data);
    return apiAction({
        types: ["GET_LOGINS_REQUESTED", "GET_LOGINS_SUCCESS", "GET_LOGINS_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getAvgKasm(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name = "avg_kasm_length";
    appendTokenName(data);
    return apiAction({
        types: ["GET_KASM_LENGTH_REQUESTED", "GET_KASM_LENGTH_SUCCESS", "GET_KASM_LENGTH_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getDestroyedKasms(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name = "destroyed_kasms";
    appendTokenName(data);
    return apiAction({
        types: ["GET_DESTROYED_KASMS_REQUESTED", "GET_DESTROYED_KASMS_SUCCESS", "GET_DESTROYED_KASMS_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getCreatedKasms(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name = "created_kasms";
    appendTokenName(data);
    return apiAction({
        types: ["GET_CREATED_KASMS_REQUESTED", "GET_CREATED_KASMS_SUCCESS", "GET_CREATED_KASMS_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getKasms(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name = "kasms";
    appendTokenName(data);
    return apiAction({
        types: ["GET_KASMS_REQUESTED", "GET_KASMS_SUCCESS", "GET_KASMS_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getErrors(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name = "get_errors";
    appendTokenName(data);
    return apiAction({
        types: ["GET_ERRORS_REQUESTED", "GET_ERRORS_SUCCESS", "GET_ERRORS_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getImageUsage(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name = "image_usage";
    appendTokenName(data);
    return apiAction({
        types: ["GET_IMAGE_USE_REQUESTED", "GET_IMAGE_USE_SUCCESS", "GET_IMAGE_USE_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function setUserUsagePageInfo({pageSize,pageNo}){
    return {
        type : 'SET_USER_USAGE_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function setDomainUsagePageInfo({pageSize,pageNo}){
    return {
        type : 'SET_DOMAIN_USAGE_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function getUserUsage(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name = "user_kasm_usage";
    appendTokenName(data);
    return apiAction({
        types: ["GET_KASM_USE_REQUESTED", "GET_KASM_USE_SUCCESS", "GET_KASM_USE_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getDomainUsage(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name = "domain_usage";
    appendTokenName(data);
    return apiAction({
        types: ["GET_DOMAIN_USE_REQUESTED", "GET_DOMAIN_USE_SUCCESS", "GET_DOMAIN_USE_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getCurrentUsers(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name = "current_users";
    appendTokenName(data);
    return apiAction({
        types: ["GET_CURRENT_USERS_REQUESTED", "GET_CURRENT_USERS_SUCCESS", "GET_CURRENT_USERS_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getCurrentKasms(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = filters;
    data.name = "current_kasms";
    appendTokenName(data);
    return apiAction({
        types: ["GET_CURRENT_KASMS_REQUESTED", "GET_CURRENT_KASMS_SUCCESS", "GET_CURRENT_KASMS_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function getAlert(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_ALERT_REQUESTED", "GET_ALERT_SUCCESS", "GET_ALERT_FAILED"],
        method: "POST",
        path: "admin/get_alert_report/",
        body: data
    });
}

export function getLogs(filters) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {
        name: "logs",
        filters: filters.filters,
        exclude_filters: filters.exclude_filters,
        limit: filters.limit || 100,
    };
    if (filters.delta) {
        data.delta= filters.delta
    }
    if (filters.start_date && filters.end_date) {
        data.start_date = filters.start_date;
        data.end_date= filters.end_date;
    }
    appendTokenName(data);
    return apiAction({
        types: ["GET_LOG_REQUESTED", "GET_LOG_SUCCESS", "GET_LOG_FAILED"],
        method: "POST",
        path: "admin/get_report/",
        body: data
    });
}

export function gethosts() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_HOSTS_REQUESTED", "GET_HOSTS_SUCCESS", "GET_HOSTS_FAILED"],
        method: "POST",
        path: "admin/get_distinct_hosts/",
        body: data
    });
}

export function setLogsPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_LOGS_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}
